import AuthzBuilder from 'common/utils/authz';
export let VagrantFeatures = /*#__PURE__*/function (VagrantFeatures) {
  VagrantFeatures["Architecture"] = "architecture";
  VagrantFeatures["Box"] = "box";
  VagrantFeatures["BoxFile"] = "boxfile";
  VagrantFeatures["Index"] = "index";
  VagrantFeatures["Provider"] = "provider";
  VagrantFeatures["Registry"] = "registry";
  VagrantFeatures["Version"] = "version";
  return VagrantFeatures;
}({});
export default function allPermissions() {
  const builder = new AuthzBuilder('vagrant', VagrantFeatures);
  builder.addCRUDActions(VagrantFeatures.Architecture);
  builder.addCRUDLActions(VagrantFeatures.Box, ['getregistryboxforbillableboxid', 'activate', 'deactivate', 'createbillableboxid', 'deactivatebillableboxid', 'getbillableidforbox', 'deleteboxrecord', 'setstateforbox']);
  builder.addCRUDActions(VagrantFeatures.BoxFile, ['download', 'upload', 'complete']);
  builder.addActions(VagrantFeatures.Index, ['search']);
  builder.addCRUDLActions(VagrantFeatures.Provider);
  builder.addCRUDLActions(VagrantFeatures.Version, ['release', 'revoke']);
  builder.addCRUDLActions(VagrantFeatures.Registry, ['activate', 'deactivate']);
  return builder;
}